import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react"; // you can replace with any icon library

const BackToTop = () => {
  const [show, setShow] = useState(false);

  // Show button when scrollY > 300px
  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={`back-top ${show ? "back-top-show" : ""}`}
      onClick={scrollToTop}
    >
      <i>
        <ArrowUp size={20} />
      </i>
    </div>
  );
};

export default BackToTop;
